import { Plugin } from 'ckeditor5/src/core';
import FileEditing from './file/fileediting';
import FileUploadEditing from './fileupload/fileuploadediting';
import FileUploadProgress from './fileupload/fileuploadprogress';
import FileUploadUI from './fileupload/fileuploadui';
export default class FileUpload extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'FileUpload';
    }
    /**
     * @inheritDoc
     */
    static get requires() {
        return [FileEditing, FileUploadEditing, FileUploadProgress, FileUploadUI];
    }
}
